import React from 'react';
import GeorefDialog from '../GeorefDialog';

/**
 * Status line for a dataset opened with /map?dataset=<id> (hooks/useDatasetRawLayers):
 * the "local coordinates" banner with the Georeference button, loading and error
 * states, and the GeorefDialog. Renders nothing without a dataset.
 */
export default function DatasetGeorefBanner({ raw }) {
  if (!raw || raw.status === 'idle') return null;
  const { status, name, error, georefInfo, georefTarget, openGeoref, saveGeoref, closeGeoref } = raw;
  const box = {
    position: 'absolute', top: 10, left: '50%', transform: 'translateX(-50%)', zIndex: 7,
    display: 'flex', alignItems: 'center', gap: 10, padding: '6px 12px', borderRadius: 8, fontSize: 12,
    background: 'rgba(13,17,23,0.92)', border: '1px solid rgba(251,191,36,0.4)', color: '#e6edf3',
  };
  return (
    <>
      {status === 'needs-georef' && (
        <div style={box} data-testid="dataset-georef-banner">
          <span>Local coordinates — georeference to place on the map</span>
          <button onClick={openGeoref} data-testid="dataset-georef-button"
            style={{ fontSize: 11, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', color: '#00d4ff', background: 'rgba(0,212,255,0.12)', border: '1px solid rgba(0,212,255,0.25)' }}>
            Georeference…
          </button>
        </div>
      )}
      {status === 'loading' && <div style={box}>Loading {name || 'dataset'} layers…</div>}
      {error && <div style={{ ...box, borderColor: 'rgba(248,113,113,0.5)' }} role="alert">{String(error)}</div>}
      {georefInfo && (
        <GeorefDialog
          title={`Georeference — ${georefTarget?.name || name || 'dataset'}`}
          initialMode={georefTarget?.initialMode}
          electrodes={georefInfo.electrodes || []}
          geometryKind={georefInfo.geometry_kind || 'line'}
          initialGeoref={georefInfo.georef}
          crsGuess={georefInfo.crs_guess}
          onSave={saveGeoref}
          onClose={closeGeoref}
        />
      )}
    </>
  );
}
